$(function () {

    $(function () {
        if ($('#results-content').length > 0) {
            handleSearch();
        }
    });

    // Search
    /** @type {JQuery<HTMLFormElement>}  */
    var $filterForm = $('#filter-form');
    var baseUrl = '/umbraco/api/news/get?type=search&nodeTypeAlias=newsDetailPage&orderby=date&desc=true&rootId_index=' + rootId;

    function handleSearch() {

        var searchStringValue = $("#searchString").val();
        var searchTypeValue = $("#searchType").val();
        var mainThemeValue = $("#mainTheme").val();
        var subThemeValue = $("#subTheme").val();

        var urlkeys = getUrlVars();

        var isGeneralOverview = !urlkeys.theme && !mainThemeValue && !urlkeys.subtheme && !subThemeValue;
        var hideOnOverviewValue = isGeneralOverview ? "false" : "";
        var hideOnFilteredOverviewValue = !isGeneralOverview ? "false" : "";

        var arrNames = ['&query=', '&pageType=', '&theme=', '&subtheme=', '&hideOnOverview=', '&hideOnFilteredOverview='];

        if (Object.keys(urlkeys).length >=  1) {
            var arrKeys = [searchStringValue, urlkeys.searchType, urlkeys.theme, urlkeys.subtheme, hideOnOverviewValue, hideOnFilteredOverviewValue];
            window.history.pushState({}, document.title, "/" + "nieuws");
            $("#searchType").val(urlkeys.searchType);
            $("#mainTheme").val(urlkeys.theme);
            $("#subTheme").val(urlkeys.subtheme);
        }
        else {
            var arrKeys = [searchStringValue, searchTypeValue, mainThemeValue, subThemeValue, hideOnOverviewValue, hideOnFilteredOverviewValue];
        }




        var resultString = '';
        for (var i = 0; i < arrKeys.length; i++) {
            //console.log(arrKeys[i])
            if (arrKeys[i] != null && arrKeys[i] != "" && typeof arrKeys[i] === 'string') {
                var encodedString = encodeURIComponent(arrKeys[i])
                resultString += arrNames[i] + encodedString;
                //console.log(resultString)
            }
        }

        var url = baseUrl + resultString;
        //console.log(url)


        $.ajax(url, {
            method: 'GET',
            contentType: 'application/json'
        }).then(function (data) {
            //console.log(data);
            createArticles(true, 12, data, searchStringValue);
        }).catch(function (error) {
            console.warn(error);
        });
    }

    function createArticles(clear, amount, data, searchvalue) {
        var contentdiv = $('#results-content');
        var loadmoreButton = $('#loadMore');
        loadmoreButton.show();

        if (clear) {
            contentdiv.html("");
        }


        var helpme = $('#helpme');
        helpme.hide();

        if (data.Items && data.Items.length < amount) {
            amount = data.Items.length
        }

        if (amount > 0 && data.Items) {
            //console.log(data.items)
            for (var i = 0; i < amount; i++) {
                var item = data.Items[i].Entity.Fields

                var col = $('<div/>', {
                    class: 'col-sm-6 col-md-4 pt-9 result-article'
                });

                var tag = $('<h4/>', {
                    class: 'h6 text- primary mt-4 mb-2 px-4'
                });
                tag.text(item.theme);

                var title = $('<h3 class="h5 mb-2 px-4">');
                title.text(item.title);

                var link = $('<a/>', {
                    class: 'overview-item px-4',
                    href: item.url,
                    target: "_self"
                });

                var img = $('<img/>', {
                    src: item.overviewImage,
                    class: "img-fluid w-100",
                    alt: item.title
                });


                col.append(link);
                link.append(img);
                link.append(tag);
                link.append(title);

                if (item.date) {
                    var div = $('<div class="w-100 px-4"></div>');

                var dateStr = item.date;
                var year = dateStr.substring(0, 4);
                var month = dateStr.substring(4, 6);
                var day = dateStr.substring(6, 8);
                var newDate = year + "-" + month + "-" + day;
                    var res = formatDate(newDate);
                    if (item.pageType != 'geen') {

                        div.text(articleTypes[item.pageType] + " | " + res);
                    }
                    else {

                        div.text(res);
                    }
                link.append(div);
            }

                contentdiv.append(col);
            }
        } else {
            var helpme = $('#helpme');
            var col = $('<div class="col-12 col-md-7 py-9">');

        var title = $('<h3 class="h3">');
        if (!searchvalue) {
            searchvalue = searchTermString;
        }
        title.text(noResultString.replace('{searchterm}', searchvalue));

            col.append(title);
            contentdiv.append(col);

            var loadmoreButton = $('#loadMore');
            loadmoreButton.hide();

            helpme.show();
        }
    }



    $('#loadMore').on('click', function (event) {
        event.preventDefault();
        loadMoreArticles();
    });

    function loadMoreArticles() {
        var offset = $('.result-article').length;
        offset = String(offset)
        //&offset=18

        var searchStringValue = $("#searchString").val();
        var searchTypeValue = $("#searchType").val();
        var mainThemeValue = $("#mainTheme").val();
        var subThemeValue = $("#subTheme").val();

        var isGeneralOverview = !mainThemeValue && !subThemeValue;
        var hideOnOverviewValue = isGeneralOverview ? "false" : "";
        var hideOnFilteredOverviewValue = !isGeneralOverview ? "false" : "";

        var arrNames = ['&query=', '&pageType=', '&theme=', '&subtheme=', '&hideOnOverview=', '&hideOnFilteredOverview=', '&offset='];
        var arrKeys = [searchStringValue, searchTypeValue, mainThemeValue, subThemeValue, hideOnOverviewValue, hideOnFilteredOverviewValue, offset];

        var resultString = '';
        for (var i = 0; i < arrKeys.length; i++) {
            //console.log(arrKeys[i])
            if (arrKeys[i] != null && arrKeys[i] != "" && typeof arrKeys[i] === 'string') {
                var encodedString = encodeURIComponent(arrKeys[i])
                resultString += arrNames[i] + encodedString;
                //console.log(resultString)
            }
        }

        var url = baseUrl + resultString;
        //console.log(url)


        $.ajax(url, {
            method: 'GET',
            contentType: 'application/json'
        }).then(function (data) {
            //console.log(data)
            if (data.Items.length == 0) {
                var loadmoreButton = $('#loadMore');
                loadmoreButton.hide();
            } else {
                createArticles(false, 12, data, searchStringValue);
            }

        }).catch(function (error) {
            console.warn(error);
        });

    }

    function getUrlVars() {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            vars[key] = decodeURIComponent(value);
        });
        return vars;
    }

    $filterForm.on('submit', function (event) {
        event.preventDefault();
        handleSearch();
    });
    $filterForm.find('input').on('blur', handleSearch);

    $('#searchType').change(function () {
        handleSearch();
    });
    $('#mainTheme').change(function () {
        handleSearch();
    });
    $('#subTheme').change(function () {
        handleSearch();
    });

    function formatDate(d) {
        var date = new Date(d);
        if (isNaN(date.getTime())) {
            return d;
        }
        else {

            var month = months;

            day = date.getDate();

            if (day < 10) {
                day = "0" + day;
            }

            return day + " " + month[date.getMonth()] + " " + date.getFullYear();
        }

    }
});
